import React from 'react'
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Dialog from "@material-ui/core/Dialog";
import FileCopyIcon from '@material-ui/icons/FileCopy';
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";
import ListItemText from "@material-ui/core/ListItemText";
import Env from "../../config/env";

class FilesPqr extends React.Component {

    render() {
        const {filesPqr, codePqr, open, onClose} = this.props;

        return (
            <Dialog
                fullWidth={true}
                maxWidth='md'
                open={open}
                onClose={onClose}
                aria-labelledby="max-width-dialog-title"
            >
                <DialogTitle id="max-width-dialog-title">Archivos adjuntos - PQR No. {codePqr}</DialogTitle>
                <DialogContent>
                    <List >
                        {filesPqr.map((val, index) => {
                            return (
                                <ListItem key={index}>
                                    <ListItemAvatar>
                                        <Avatar>
                                            <FileCopyIcon />
                                        </Avatar>
                                    </ListItemAvatar>
                                    <a href={`${Env.UrlFiles}${val.nombre}`} target='_blank' rel="noopener noreferrer">
                                        <ListItemText primary={val.name} secondary="" />
                                    </a>
                                </ListItem>
                            );
                        })}
                    </List>
                </DialogContent>
            </Dialog>
        );
    }
}

export default FilesPqr